<div id="{{position}}" class="position-relative" [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }">
  <div>
    <header class="app-header-background header pt-40 pb-40"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="app-header-headline">
        <h1 [class]="'center mb-20 '+titleSize" [ngStyle]="{ 'color': textColor }"> <img class="icons-social-media"
            src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/logos/twitter-icon.png" alt=""> {{title}}
        </h1>
      </div>
      <div *ngIf="(isBrowser$ | async)">
        <div class="twitter-timeline-content">
          <ngx-twitter-timeline [data]="{sourceType: 'url', url: twitterLink}" [opts]="{tweetLimit: 5}">
          </ngx-twitter-timeline>
        </div>
      </div>
    </header>
  </div>
</div>